<template>
  <div id="#assembly-step">
    <div class="row">
      <div class="col-6">
        <label>Sub-assembly/part name</label>
        <input
          type="text"
          class="form-control"
          v-model="step.name"
          placeholder="Sub-assembly/part name"
        />
      </div>
      <div class="col-6">
        <label>Condition</label>
        <input
          type="text"
          class="form-control"
          v-model="step.condition"
          placeholder="Optional condition formula"
        />
      </div>
    </div>

    <ul class="nav nav-tabs mt-5">
      <li class="nav-item">
        <a
          class="nav-link"
          :class="{ active: selectedItemIndex === 0 }"
          aria-current="page"
          href="#"
          @click.prevent="selectedItemIndex = 0"
          >Items
          <span class="badge text-light bg-secondary">{{
            step.items ? step.items.length : 0
          }}</span></a
        >
      </li>
      <li class="nav-item" v-if="step.condition">
        <a
          class="nav-link"
          :class="{ active: selectedItemIndex === 1 }"
          href="#"
          @click.prevent="selectedItemIndex = 1"
          >Alternative items
          <span class="badge text-light bg-secondary">{{
            step.elseItems ? step.elseItems.length : ""
          }}</span></a
        >
      </li>
    </ul>
    <div class="row mt-5">
      <AssemblyStepItems
        v-if="selectedItemIndex === 0"
        class="col-12"
        v-model="step.items"
      >
      </AssemblyStepItems>
      <AssemblyStepItems
        v-if="selectedItemIndex === 1"
        class="col-12"
        v-model="step.elseItems"
      ></AssemblyStepItems>
    </div>
  </div>
</template>

<script>
import AssemblyStepItems from "./AssemblyStepItems";

export default {
  components: {
    AssemblyStepItems,
  },
  props: {
    value: Object,
  },
  data() {
    return {
      selectedItemIndex: 0,
    };
  },
  computed: {
    step: {
      get: function () {
        return this.value;
      },
      set: function (value) {
        this.$emit("input", value);
      },
    },
  },
};
</script>

<style scoped>
.step-wrapper {
  border-top: 2px solid silver;
  padding-top: 3px;
  margin-top: 6px;
}

.step-else {
  border-top: 1px solid silver;
  padding-top: 3px;
}
label {
  display: block;
}
</style>